import { render, staticRenderFns } from "./CRUDCargosSistema.vue?vue&type=template&id=404798f0"
import script from "./CRUDCargosSistema.vue?vue&type=script&lang=ts"
export * from "./CRUDCargosSistema.vue?vue&type=script&lang=ts"
import style0 from "./CRUDCargosSistema.vue?vue&type=style&index=0&id=404798f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports